import { createDashboardList, createDashboardSections, fetchDashboard, fetchUserIcon } from "~/util/dashboard";
import createHeaderButton from "~/ui/headerbutton";
import { CLOSE_16 } from "@sznds/icons";
import Header from "~/ui/header";
import Content from "./content";
import { fragment, node, icon, text } from "~/util/dom";
import { createVerifiedUserTooltip } from "~/util/userweb";
import { _ } from "~/i18n";
import Avatar from "~/ui/avatar";
import { getUserPremiumByUserPublicId } from "~/util/providers/premium";

interface IDashboardOptions {
	userId: string;
	header: Header;
}

export default class Dashboard extends Content {
	_sections: HTMLDivElement;

	_list: HTMLDivElement;

	_error: HTMLParagraphElement;

	_userId: string;

	_header: Header;

	constructor({
		userId,
		header,
	}: IDashboardOptions) {
		super();

		this._userId = userId;
		this._header = header;
		this._sections = node("div", { className: "user-profile-section-list" });
		this._list = node("div", { className: "dashboard-last-list" });
		this._error = node("p", { className: "dashboard-error" });

		const closeButton = createHeaderButton({
			icon: CLOSE_16,
			innerHTML: _("close"),
		});

		closeButton.setAttribute("data-log-publicProfile", "1");
		this._header.leftButtons.appendChild(closeButton);
		closeButton.addEventListener("click", () => {
			Mapy.getComponent("userProfile").deactivate();
			Mapy.getComponent("history").save();
		});

		this._load();
	}

	async _load() {
		this._error.textContent = _("userProfile.error500");

		// nacteme uzivateluv dashboard
		try {
			this._error.remove();
			const response = await fetchDashboard(this._userId);

			if (response.status === 200) {
				const json = await response.json();
				const data = {
					// eslint-disable-next-line camelcase
					...json.data?.saved_reviews ? { saved_reviews: json.data.saved_reviews } : {},
					// eslint-disable-next-line camelcase
					...json.data?.uploaded_photos ? { uploaded_photos: json.data.uploaded_photos } : {},
					user: json.data?.user,
				};
				const frag = fragment();

				frag.appendChild(node("div", { className: "ui-header__userprofile-title" }, data.user?.userName));

				if (data.user?.bankId) {
					const verifiedIcon = icon("verifieduser24");

					verifiedIcon.classList.add("ui-header__userprofile-icon");
					frag.appendChild(verifiedIcon);
					createVerifiedUserTooltip(verifiedIcon);
				}

				this._header.title = frag;

				getUserPremiumByUserPublicId(this._userId).then(userPremium => {
					this._header.premium = userPremium?.premium ? "mapy" : "none";
					this._header.fanda = userPremium?.isFanda;
				});

				Mapy.getComponent("userProfile").isActive() && Mapy.SEO.set(_("userProfile.seo", { user: data.user?.userName }));

				this._sections.innerHTML = "";
				this._sections.appendChild(createDashboardSections({
					data,
					isCurrentUser: false,
					userPublicId: this._userId,
				}));
				this._list.innerHTML = "";
				this._list.appendChild(createDashboardList(
					data,
					() => {},
					false,
				));

				this._container.appendChild(this._sections);
				this._container.appendChild(this._list);

				const headline = node("h4", { className: "bp-userprofile" });

				// nacteni ikony uzivatele
				try {
					const responseIcon = await fetchUserIcon(this._userId);
					const jsonIcon = await responseIcon.json();

					headline.appendChild(new Avatar({
						src: `${jsonIcon.data.privateUrl}/64`,
					}).node);

					headline.classList.add("has-avatar");
				} catch (ex) {
					//
				}

				headline.appendChild(text(data.user?.userName));
				Mapy.getComponent("layout").setBottomPanel(headline);
			} else if (response.status === 404) {
				this._error.textContent = _("userProfile.error404");
				throw new Error(`Dashboard mel stav ${response.status}.`);
			} else {
				throw new Error(`Dashboard mel stav ${response.status}.`);
			}
		} catch (ex) {
			// eslint-disable-next-line no-console
			console.log(ex);
			this._sections.remove();
			this._list.remove();
			Mapy.getComponent("userProfile").isActive() && Mapy.SEO.set(_("userProfile.seoError"));
			this._container.appendChild(this._error);
		}
	}
}
